var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "50px",
    viewBox: "0 0 60 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "692C6867-0126-435A-A9B7-4F40EEE0024B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "1.94284607e-15 0 60 0 60 50 1.94284607e-15 50"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage",
    transform: "translate(-572.000000, -5920.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbols/Icons/Social/Telegram-large",
    transform: "translate(572.000000, 5920.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.435575,27.75425 L22.6329795,41.59925 L23.5654583,32.83175 C23.5654583,32.83175 39.7825892,18.20675 49.0273787,9.86675 C49.2973726,9.62425 49.3348717,9.21175 49.1098769,8.92425 C48.8873819,8.63925 48.4773913,8.57175 48.1698983,8.76425 C37.4551421,15.60925 18.435575,27.75425 18.435575,27.75425 M45.9599486,49.44925 C46.7649302,50.01675 47.8024066,50.16175 48.7273856,49.80925 C49.6523645,49.45925 50.332349,48.66675 50.5373444,47.70925 C52.7097949,37.49925 57.979675,11.65925 59.95713,2.37175 C60.1071266,1.66925 59.8571322,0.94175 59.3071448,0.47425 C58.7571573,0.00675 57.9946746,-0.12575 57.3146901,0.12425 C46.8324287,4.00425 14.5506635,16.11675 1.35596377,20.99925 C0.518482833,21.30925 -0.0265047625,22.11675 0.000994611646,22.99925 C0.0309939288,23.88425 0.625980387,24.64925 1.48346087,24.90675 C7.40082619,26.67675 15.1681494,29.14175 15.1681494,29.14175 C15.1681494,29.14175 18.7980668,40.10175 20.6905237,45.67925 C20.9280183,46.37675 21.4755058,46.92925 22.1979894,47.11675 C22.917973,47.30425 23.6879555,47.10675 24.2254432,46.59925 C27.2653741,43.73175 31.9652671,39.29175 31.9652671,39.29175 C31.9652671,39.29175 40.8950638,45.83925 45.9599486,49.44925",
    id: "Fill-1",
    fill: "#330366",
    mask: "url(#mask-2)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.c6f5602a19b0dd0d191c5c8c4828abda.svg";
export { ForwardRef as ReactComponent };